export const floatValue = (e) => {
  const value = `${e.target.value}`.replace(/[^\.\,\d]/, '');
  return value ? parseFloat(value) : 0;
};

export const integerValue = (e) => {
  const value = `${e.target.value}`.replace(/[^\d]/, '');
  return value ? parseInt(value) : '';
};

export const integerValueCanStartFromZero = (e) => {
  const value = e.target.value;
  if (/^\d*$/.test(value)) {
    return value
  }
};

export const floatValueSign = (e) => {
  const valueStr = `${e.target.value}`.replace(/[^-?\d+(\.\d+)?$]/, '');
  return valueStr ? valueStr : '';
};

export const limitValueMaxFloat = (max) => (e) => {
  const value = `${e.target.value}`.replace(/[^\d]/, '');
  if (value && parseFloat(value) > max) {
    return parseFloat(max).toFixed(2);
  } else {
    return value ? value : '';
  }
};

export const limitValueRangeFloat = (maxLength, min, max) => (e) => {
  const value = `${e.target.value}`.replace(/[^\.\,\d]/, '');
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else {
    return value.slice(0, maxLength) || '';
  }
};

